import { apiClientes } from "../config/api";
import { QuestionarioToPassword } from "../interfaces/entities/QuestionarioToPassword";
import { Response } from "../interfaces/services/Response";


export const getQuestValidacaoUsrContr = async (idUsrContr: string): Promise<any | null> => {
  try {
    const response = await apiClientes.get(`/questionario/getquestvalidacaousrcontr?idUsrContr=${idUsrContr}`);
    return response;
  } catch (error: any) {
    const errorData = error?.response?.data;
    return errorData
  }
}

export const postRespostaQuestValidacaoUsrContr = async (questionario: QuestionarioToPassword): Promise<any | null> => {
  try {
    const response = await apiClientes.post(`/questionario/postrespostaquestvalidacaousrcontr`, questionario);
    return response;
  } catch (error: any) {
    const errorData = error?.response?.data;
    return errorData
  }
}